//angular
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations, fadeInAnimation } from '../../_shared/animations';
import { collectionOfNavOption, SideNavMenuOptions } from '../../app.data';
import { StorageService } from '../../_core/services';
import { filter } from 'rxjs/operators';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [fadeInAnimation, AppAnimations],
  selector: 'app-base',
  templateUrl: './layout.component.html'
})

export class LayoutBaseComponent implements OnDestroy {
  collectionOfNavOption: Array<any> = collectionOfNavOption
  companyName: string;
  inputSearchIsValid: boolean = false;
  inputSearchQuery: string = '';
  optionQuickAccessClicked: boolean = false;
  sideNavMenuOptionActive: SideNavMenuOptions;
  startSearch: boolean = false;
  toggleSideNav: boolean = true;
  userInitials: string;
  userRole: string;
  private subs = new Unsubscriber();

  constructor(
    private _router: Router,
    private _iconRegistry: MatIconRegistry,
    private _meta: MetaService,
    private _sanitizer: DomSanitizer,
    private _storage: StorageService
  ) {
    this._iconRegistry.addSvgIcon('ico-analytics',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-analytics-01.svg'));
    this._iconRegistry.addSvgIcon('ico-channels',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-channels-02.svg'));
    this._iconRegistry.addSvgIcon('ico-customers',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-customers-02.svg'));
    this._iconRegistry.addSvgIcon('ico-dashboard',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-dashboard-02.svg'));
    this._iconRegistry.addSvgIcon('ico-dashboard-2',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-dashboard-03.svg'));
    this._iconRegistry.addSvgIcon('ico-orders',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-orders-01.svg'));
    this._iconRegistry.addSvgIcon('ico-products',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-products-01.svg'));
    this._iconRegistry.addSvgIcon('ico-subscriptions',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-subscriptions-01.svg'));
    this._iconRegistry.addSvgIcon('logo-rebillia',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia.svg'));

    this._iconRegistry.addSvgIcon('ico-account',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-customers-01.svg'));
    this._iconRegistry.addSvgIcon('ico-add',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-add-04.svg'));
    this._iconRegistry.addSvgIcon('ico-back',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-company',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-company-03.svg'));
    this._iconRegistry.addSvgIcon('ico-goto-website',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-link-01.svg'));
    this._iconRegistry.addSvgIcon('ico-home',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-dashboard-01.svg'));
    this._iconRegistry.addSvgIcon('ico-integrations',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-integrations-01.svg'));
    this._iconRegistry.addSvgIcon('ico-invoices',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-invoices-01.svg'));
    this._iconRegistry.addSvgIcon('ico-logs',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-logs-01.svg'));
    this._iconRegistry.addSvgIcon('ico-more',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-more-02.svg'));
    this._iconRegistry.addSvgIcon('ico-next',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-next-01.svg'));
    this._iconRegistry.addSvgIcon('ico-account-notifications',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-notifications-03.svg'));
    this._iconRegistry.addSvgIcon('ico-quick-access',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-rocket-01.svg'));
    this._iconRegistry.addSvgIcon('ico-search',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-search-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
    this._iconRegistry.addSvgIcon('ico-support',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-phone-01.svg'));
    this._iconRegistry.addSvgIcon('ico-wizard',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-wizard-01.svg'));
    this._iconRegistry.addSvgIcon('logo-rebillia-blue',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia-blue.svg'));
    this._iconRegistry.addSvgIcon('logo-rebillia-white',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia-white.svg'));

    this.subs.addSub = this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        let vec  = event.url.split('/');
        if (vec.length > 2){
          switch (vec[2]) {
            case SideNavMenuOptions.advancedSettings:
              this.setSideNavMenuOptionActive(SideNavMenuOptions.advancedSettings);
              break;
            case SideNavMenuOptions.analytics:
              this.setSideNavMenuOptionActive(SideNavMenuOptions.analytics);
              break;
            case SideNavMenuOptions.customer:
              this.setSideNavMenuOptionActive(SideNavMenuOptions.customer);
              break;
            case SideNavMenuOptions.dashboard:
              this.setSideNavMenuOptionActive(SideNavMenuOptions.dashboard);
              break;
            case SideNavMenuOptions.invoices:
              this.setSideNavMenuOptionActive(SideNavMenuOptions.invoices);
              break;
            case SideNavMenuOptions.integrations:
              if (vec[3] === SideNavMenuOptions.salesChannels){
                this.setSideNavMenuOptionActive(SideNavMenuOptions.integrations);
              }
              break;
            case SideNavMenuOptions.products:
              this.setSideNavMenuOptionActive(SideNavMenuOptions.products);
              break;
            case SideNavMenuOptions.settings:
              if (vec[3] == SideNavMenuOptions.store) {
                this.setSideNavMenuOptionActive(SideNavMenuOptions.store);
              } else {
                this.setSideNavMenuOptionActive(SideNavMenuOptions.advancedSettings);
              }
              break;
            case SideNavMenuOptions.subscriptions:
              this.setSideNavMenuOptionActive(SideNavMenuOptions.subscriptions)
              break;
            case SideNavMenuOptions.transactions:
              this.setSideNavMenuOptionActive(SideNavMenuOptions.transactions);
              break;
          }
        }
      });

    this._meta.setCompanyCurrencyBase();
    this._meta.setCompanySettings();
  }

  onClickSideNavHandler() {
    this.toggleSideNav = !this.toggleSideNav;
  }

  onInputSearchKeyup(_event, _inputSearchQuery) {
    if (_inputSearchQuery != '') {
      this.inputSearchIsValid = true;
    } else {
      this.inputSearchIsValid = false;
    }
    if (_event.key === 'Enter') {
      this.openSearchPanel(_inputSearchQuery);
    }
  }

  openSearchPanel(_inputSearchQuery) {
    this.inputSearchQuery = _inputSearchQuery;
  }

  setSideNavMenuOptionActive(_sideNavMenuOptionActive:SideNavMenuOptions){
    this.sideNavMenuOptionActive = _sideNavMenuOptionActive;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
